export const CLIENT_REPORTS_VALIDATION_RULES = {
  reportType: {
    isRequiredTrim: {
      value: true,
    },
  },
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  languageCode: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/clientReportsValidationRules.js